import EnvironmentSettings from "../Models/EnvironmentSettings";
import TenantManager from "./TenantManager";
import UsersApi from "./UsersApi";

const baseUrl =
  EnvironmentSettings.Environment === "dev"
    ? EnvironmentSettings.LocalUrl
    : EnvironmentSettings.LiveUrl;

async function getTableRecords(filters) {
  try {
    const params = new URLSearchParams(filters);
    const url = baseUrl + "receipts";
    const response = await fetch(url + (params.toString() ? "?" + params.toString() : ""), {
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching receipts:", error);
    throw error;
  }
}

async function getBalanceHistoryForPackage(packageId, filters) {
  try {
    const params = new URLSearchParams(filters);
    params.append("packageId", packageId);

    const url = baseUrl + "Accounting/GetBalanceHistoryByPackage";
    const response = await fetch(url + (params.toString() ? "?" + params.toString() : ""), {
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching balance history:", error);
    throw error;
  }
}

async function getTableRecordsForPackage(packageId, filters) {
  try {
    const params = new URLSearchParams(filters);

    params.append("packageId", packageId);

    const url = baseUrl + "receipts";
    const response = await fetch(url + (params.toString() ? "?" + params.toString() : ""), {
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
    });

    return await response.json();
  } catch (error) {
    console.error("Error fetching receipts:", error);
    throw error;
  }
}

async function findReceiptFromAccountingSession(accountingSessionId) {
  const url = baseUrl + "receipts/findIdByAccountingSession/" + accountingSessionId;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${await UsersApi.GetToken()}`,
      tenant: TenantManager.getTenant(await UsersApi.GetToken()),
    },
  });

  const data = await response.json();
  if (response.ok) return data;

  throw new Error(data.message);
}
async function downloadReceiptPdf(receiptId) {
  try {
    const url = baseUrl + "receipts/pdf/" + receiptId;
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download receipt");
    }

    return await response.blob();
  } catch (error) {
    console.error("Error downloading receipt:", error);
    throw error;
  }
}

export {
  getTableRecords,
  findReceiptFromAccountingSession,
  getTableRecordsForPackage,
  downloadReceiptPdf,
  getBalanceHistoryForPackage,
};
